import { useState } from 'react';

function useTablePagination() {
  const pageSizes: number[] = [10, 12, 15, 20];
  const defaultPageSize = pageSizes[1];

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: defaultPageSize,
  });
  const [totalPages, setTotalPages] = useState<number>(0);

  return {
    pageSizes,
    defaultPageSize,
    paginationModel,
    totalPages,
    setPaginationModel,
    setTotalPages,
  };
}

export default useTablePagination;
